import React from 'react'
import { Store } from 'lucide-react'
import { $DCprimaryColor } from 'pixel-base'
import styled from 'styled-components'
import DCLogo from 'utils/icons/dcIcon'
import StoreDaraz from 'utils/icons/store-daraz'
import StoreShopify from 'utils/icons/store-shopify'
import StoreWix from 'utils/icons/store-wix'
import StoreWoocom from 'utils/icons/store-woocom'
import logo from '../assets/fav.svg'

export interface PixelTabIconsProps {
  className?: string
  store_type: string
  isActive?: boolean
}

interface ITabIcons {
  store_type: string
  icon: React.ReactNode
}

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 8px;

  svg {
    width: 24px;
    height: 24px;
    /* fill: ${$DCprimaryColor}; */
  }
`

const TabIcons = [
  {
    store_type: 'woocom',
    icon: <StoreWoocom color={$DCprimaryColor} />,
  },
  {
    store_type: 'ems',
    icon: <img width={24} height={24} src={logo} alt="EMS" />,
  },
  {
    store_type: 'daraz',
    icon: <StoreDaraz color={$DCprimaryColor} />,
  },
  {
    store_type: 'shopify',
    icon: <StoreShopify color={$DCprimaryColor} />,
  },
  {
    store_type: 'wix',
    icon: <StoreWix color={$DCprimaryColor} />,
  },
]

const StyledPixelTabsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* svg {
    fill: ${$DCprimaryColor};
  } */
`

export const PixelTabIcons = React.forwardRef<
  HTMLDivElement,
  PixelTabIconsProps
>(({ className, store_type }, ref) => {
  return (
    <StyledPixelTabsIcon ref={ref} className={className}>
      {store_type === null || store_type === '0' ? (
        <IconWrapper>
          <Store color={$DCprimaryColor} />
        </IconWrapper>
      ) : (
        <>
          {TabIcons.map((item: ITabIcons, index) => {
            if (item.store_type === store_type) {
              return <IconWrapper key={index}>{item.icon}</IconWrapper>
            }
            return null
          })}
        </>
      )}
    </StyledPixelTabsIcon>
  )
})

PixelTabIcons.displayName = 'PixelTabIcons'

export default PixelTabIcons
